import { createSlice } from "@reduxjs/toolkit";
import helper from "../../Helper";
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
  loading: false,
  getGameRes: [],
  getAllMineRes: [],
  getSingleMineRes: [],
  getActiveGameRes: [],
  getActiveCurrency: [],
  getStatisticsdata: [],
  getGameListsRes: [],
  gameSearchRes: [],
  singleBetRes: [],
  error: "",
};

const gameSlice = createSlice({
  name: "game",
  initialState,
  reducers: {
    game: (state, action) => {
      state.getGameRes = action.payload;
    },
    mine: (state, action) => {
      state.getAllMineRes = action.payload;
    },
    singleMine: (state, action) => {
      state.getSingleMineRes = action.payload;
    },
    activeGame: (state, action) => {
      state.getActiveGameRes = action.payload;
    },

    activeCurrency: (state, action) => {
      state.getActiveCurrency = action.payload;
    },
    getstatistics: (state, action) => {
      state.getStatisticsdata = action.payload;
    },
    getGamesRes: (state, action) => {
      state.getGameListsRes = action.payload;
    },
    gameSearch: (state, action) => {
      state.gameSearchRes = action.payload;
    },
    betHistory: (state, action) => {
      state.singleBetRes = action.payload;
    },
  },
});

export const {
  game,
  mine,
  singleMine,
  activeGame,
  activeCurrency,
  getstatistics,
  getGamesRes,
  gameSearch,
  betHistory,
} = gameSlice.actions;
export default gameSlice.reducer;

export const getGames =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.PostData(
          `${frontUrl}/${API?.GET_GAME_ROUTE}`,
          data
        );
        callback(response);
        dispatch(game(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getAllMines =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.GetData(
          `${frontUrl}/${API?.GET_ALL_MINES}`
        );
        callback(response);
        dispatch(mine(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getSingleMine =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.PostData(
          `${frontUrl}/${API?.GET_SINGLE_MINE}`,
          data
        );
        callback(response);
        dispatch(singleMine(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getActiveGames =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.GetData(
          `${frontUrl}/${API?.GET_ACTIVE_GAME_LISTS}`,
          data
        );
        callback(response);
        dispatch(activeGame(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getActiveCurrency =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.GetData(
          `${frontUrl}/${API?.GET_ACTIVE_CURRENCY}`,
          data
        );
        callback(response);
        dispatch(activeCurrency(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getstatisticsdata =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.PostData(
          `${frontUrl}/${API?.GET_USER_STATISTICS}`,
          data
        );
        callback(response);
        dispatch(getstatistics(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };
export const getGamesLists =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.GetData(
          `${frontUrl}/${API?.GET_ALL_GAME_LISTS}`,
          data
        );
        callback(response);
        dispatch(getGamesRes(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };


export const getSearchGames =
  (data, callback = () => { }) =>
    async (dispatch) => {
      try {
        const response = await helper.PostData(
          `${frontUrl}/${API?.GET_ALL_GAMES_SEARCH}`,
          data
        );
        callback(response);
        dispatch(gameSearch(response.data));
        return response.data;
      } catch (e) {
        return console.error(e.message);
      }
    };

export const getSingleBetView = (data, callback = () => { }) =>
  async dispatch => {
    try {
      const response = await helper.PostData(`${frontUrl}/${API?.GET_SINGLE_GAME_HISTORY}`, data);
      callback(response)
      dispatch(betHistory(response?.data))
      return response?.data
    } catch (e) {
      return console.error(e.message)
    }
  }
